import { render, staticRenderFns } from "./ReportByAgeAndWeek.vue?vue&type=template&id=b8a44190"
import script from "./ReportByAgeAndWeek.vue?vue&type=script&lang=js"
export * from "./ReportByAgeAndWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports